import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    detailPeriodChannel = new Subject();
    processChannel = new Subject();
    downloadDraftSKChannel = new Subject();
    repository = new IndexRepository()
   
    constructor() {
        this.detailPeriodChannel.next({status: apiResponse.INITIAL})
        this.processChannel.next({status: apiResponse.INITIAL})
        this.downloadDraftSKChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetailPeriod = async (query) => {
        try {
            this.detailPeriodChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetailPeriod(query).then((result) => {
                this.detailPeriodChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailPeriodChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchProcess = async (query) => {
        try {
            this.processChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchProcess(query).then((result) => {
                this.processChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.processChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchDownloadDraftSK = async (query) => {
        try {
            this.downloadDraftSKChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDownloadDraftSK(query).then((result) => {
                this.downloadDraftSKChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.downloadDraftSKChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

}

export default IndexBloc